import { render } from "./ManifestWaypointTable.vue?vue&type=template&id=0d6b151c&scoped=true"
import script from "./ManifestWaypointTable.vue?vue&type=script&lang=js"
export * from "./ManifestWaypointTable.vue?vue&type=script&lang=js"

import "./ManifestWaypointTable.vue?vue&type=style&index=0&id=0d6b151c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d6b151c"]])

export default __exports__